const LOG_KEYS = [
    'twoPointsMade',
    'twoPointAttempts',
    'threePointsMade',
    'threePointAttempts',
    'freeThrowsMade',
    'freeThrowAttempts',
    'assists',
    'offensiveRebounds',
    'defensiveRebounds',
    'blockedShots',
    'steals',
    'turnovers',
    'personalFouls',
    'technicalFouls'
]

// Same formula as the backend's MatchStat.pir
function withDerivedStats(stats) {
    const points = stats.twoPointsMade * 2 + stats.threePointsMade * 3 + stats.freeThrowsMade
    const rebounds = stats.offensiveRebounds + stats.defensiveRebounds
    const missedFieldGoals = stats.twoPointAttempts + stats.threePointAttempts - stats.twoPointsMade - stats.threePointsMade
    const missedFreeThrows = stats.freeThrowAttempts - stats.freeThrowsMade
    const pir = (points + rebounds + stats.assists + stats.steals + stats.blockedShots) -
        (missedFieldGoals + missedFreeThrows + stats.turnovers + stats.personalFouls + stats.technicalFouls)
    return { ...stats, points, rebounds, pir }
}

// Sums the match stat logs of a single period per player
export function getPeriodPlayerStats(logs, period) {
    const byPlayer = {}
    ;(Array.isArray(logs) ? logs : []).forEach(log => {
        if (Number(log.period) !== Number(period) || !log.playerId) return
        if (!byPlayer[log.playerId]) {
            byPlayer[log.playerId] = LOG_KEYS.reduce((acc, key) => {
                acc[key] = 0
                return acc
            }, { playerId: log.playerId, teamId: log.teamId })
        }
        LOG_KEYS.forEach(key => {
            byPlayer[log.playerId][key] += Number(log[key]) || 0
        })
    })
    return Object.values(byPlayer).map(withDerivedStats)
}

// Highest PIR of the period (points break ties), joined with the roster entry from the match
export function getPeriodBestPerformer(logs, match, period) {
    const candidates = getPeriodPlayerStats(logs, period)
        .filter(stats => stats.points || stats.rebounds || stats.assists || stats.steals || stats.blockedShots)
        .sort((a, b) => (b.pir - a.pir) || (b.points - a.points))
    if (!candidates.length) return null

    const stats = candidates[0]
    const team = [match?.team1, match?.team2].find(t => t && Number(t.id) === Number(stats.teamId))
    const player = (team?.players || []).find(p => Number(p.id) === Number(stats.playerId))
    if (!player) return null

    return { player, team, stats }
}

// Adds a { period: points } map into 1st-4th + OT buckets (overtimes grouped under 'ot')
export function bucketPeriodScore(periodScore, into = { 1: 0, 2: 0, 3: 0, 4: 0, ot: 0 }) {
    Object.entries(periodScore || {}).forEach(([period, points]) => {
        const key = Number(period) > 4 ? 'ot' : Number(period)
        if (key in into) into[key] += Number(points) || 0
    })
    return into
}
